export default __webpack_public_path__ + "static/media/quikstart-2.d6ccf048.svg";